/* Mer Torlen-Landingpage: Galerie, Paketwahl, Karussells, Hochzählen. Läuft einmal je Seite,
   auch wenn mehrere Sections die Datei einbinden. Sichtbarkeit über scroll statt IntersectionObserver
   (Theme-Falle „IntersectionObserver meldet nie“). */
(function(){
  if (window.__mtl) return; window.__mtl = true;
  function alle(sel, wurzel){ return [].slice.call((wurzel||document).querySelectorAll(sel)); }

  function start(){
    // Galerie
    alle('[data-mtl-galerie]').forEach(function(g){
      var haupt = g.querySelector('[data-mtl-haupt]'), daumen = alle('[data-mtl-bild]', g), i = 0;
      function zeige(n){ if(!daumen.length) return; i=(n+daumen.length)%daumen.length;
        haupt.src = daumen[i].getAttribute('data-mtl-bild'); daumen.forEach(function(d,j){ d.classList.toggle('an', j===i); }); }
      daumen.forEach(function(d,j){ d.addEventListener('click', function(){ zeige(j); }); });
      var l = g.querySelector('.mtl-pfeil.l'), r = g.querySelector('.mtl-pfeil.r');
      if(l) l.addEventListener('click', function(){ zeige(i-1); });
      if(r) r.addEventListener('click', function(){ zeige(i+1); });
    });

    // Paketwahl
    alle('[data-mtl-form]').forEach(function(f){
      var menge = f.querySelector('[data-mtl-menge]'), kauf = f.closest('.mtl-kauf');
      function setze(p){
        alle('.mtl-paket', f).forEach(function(x){ x.classList.toggle('an', x===p); });
        menge.value = p.getAttribute('data-menge');
        alle('[data-mtl-preis]', kauf).forEach(function(e){ e.textContent = p.getAttribute('data-preis'); });
        alle('[data-mtl-alt]', kauf).forEach(function(e){ e.textContent = p.getAttribute('data-alt'); });
        alle('[data-mtl-spar]', kauf).forEach(function(e){ e.textContent = (e.getAttribute('data-vorn')||'') + p.getAttribute('data-spar'); });
      }
      alle('.mtl-paket', f).forEach(function(p){ p.addEventListener('click', function(){ setze(p); }); });
      var an = f.querySelector('.mtl-paket.an'); if(an) setze(an);
    });

    // Karussells
    alle('[data-mtl-karussell]').forEach(function(k){
      var spur = k.querySelector('.mtl-spur'), karten = alle('.mtl-karte', spur), punkte = alle('.mtl-punkte i', k);
      function schritt(){ return karten.length > 1 ? karten[1].offsetLeft - karten[0].offsetLeft : spur.clientWidth; }
      function aktiv(){ var n = Math.round(spur.scrollLeft / schritt());
        if (spur.scrollLeft + spur.clientWidth >= spur.scrollWidth - 4) n = karten.length - 1;
        punkte.forEach(function(p,j){ p.classList.toggle('an', j===n); }); }
      var l = k.querySelector('[data-mtl-zurueck]'), r = k.querySelector('[data-mtl-vor]');
      if(l) l.addEventListener('click', function(){ spur.scrollBy({left:-schritt(), behavior:'smooth'}); });
      if(r) r.addEventListener('click', function(){ spur.scrollBy({left:schritt(), behavior:'smooth'}); });
      spur.addEventListener('scroll', function(){ window.requestAnimationFrame(aktiv); }, {passive:true});
      aktiv();
    });

    // Hochzählen (Endwert steht schon im Markup)
    var zahlen = alle('[data-mtl-ziel]').filter(function(z){ return !isNaN(parseFloat(z.getAttribute('data-mtl-ziel'))); });
    zahlen.forEach(function(z){ z.textContent = '0'; });
    function zaehle(z){ var ziel = parseFloat(z.getAttribute('data-mtl-ziel')), t0 = null;
      function lauf(t){ if(!t0) t0 = t; var a = Math.min(1, (t-t0)/1400), e = 1 - Math.pow(1-a, 3);
        z.textContent = Math.round(ziel*e); if(a<1) window.requestAnimationFrame(lauf); }
      window.requestAnimationFrame(lauf); }
    function pruefe(){ zahlen = zahlen.filter(function(z){ var r = z.getBoundingClientRect();
      if (r.top < window.innerHeight*0.92 && r.bottom > 0){ zaehle(z); return false; } return true; }); }
    var wartet = false;
    window.addEventListener('scroll', function(){ if(wartet) return; wartet = true;
      window.requestAnimationFrame(function(){ wartet = false; pruefe(); }); }, {passive:true});
    pruefe();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
